import { render } from "./ZoomableMediaContainer.vue?vue&type=template&id=475d2446&scoped=true"
import script from "./ZoomableMediaContainer.vue?vue&type=script&lang=js"
export * from "./ZoomableMediaContainer.vue?vue&type=script&lang=js"

import "./ZoomableMediaContainer.vue?vue&type=style&index=0&id=475d2446&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475d2446"]])

export default __exports__